module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-tabs', {
    staticClass: "tab-nav",
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "姓名查询"
    }
  }, [_c('van-form', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '姓名不能为空'
      }],
      "label": "姓名",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.idCard,
        message: '请输入正确的身份证号'
      }],
      "error-message-align": "right",
      "label": "身份证",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "省市业务"
    }
  }, [_c('van-form', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "submit": _vm.onSubmit2,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.province ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "省市地区",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "业务类型"
    },
    on: {
      "click": function($event) {
        _vm.showYewuPicker = true
      }
    },
    model: {
      value: (_vm.formData.yewuName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "yewuName", $$v)
      },
      expression: "formData.yewuName"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showYewuPicker),
      callback: function($$v) {
        _vm.showYewuPicker = $$v
      },
      expression: "showYewuPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.yewuColumns,
      "show-toolbar": "",
      "default-index": 0
    },
    on: {
      "cancel": function($event) {
        _vm.showYewuPicker = false
      },
      "confirm": _vm.onYewuConfirm
    }
  })], 1), _vm._v(" "), _c('van-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subLabel),
      expression: "subLabel"
    }],
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": _vm.subLabel
    },
    on: {
      "click": function($event) {
        _vm.showSubPicker = true
      }
    },
    model: {
      value: (_vm.formData.subName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "subName", $$v)
      },
      expression: "formData.subName"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showSubPicker),
      callback: function($$v) {
        _vm.showSubPicker = $$v
      },
      expression: "showSubPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.subColumns,
      "show-toolbar": "",
      "default-index": 0
    },
    on: {
      "cancel": function($event) {
        _vm.showSubPicker = false
      },
      "confirm": _vm.onSubConfirm
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.list), function(item, k) {
    return _c('div', {
      key: k
    }, [_c('van-divider', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.list), function(row, i) {
      return _c('van-cell-group', {
        key: i
      }, [(item.name == '教练资质') ? _c('div', [_c('van-cell', {
        attrs: {
          "title": "姓名",
          "value": row.name
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "身份证",
          "value": row.num
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "等级",
          "value": row.grade
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "编号",
          "value": row.code
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "日期",
          "value": row.registdate
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.name == '裁判资质') ? _c('div', [_c('van-cell', {
        attrs: {
          "title": "姓名",
          "value": row.name
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "身份证",
          "value": row.num
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "等级",
          "value": row.grade
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "编号",
          "value": row.code
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "日期",
          "value": row.registdate
        }
      })], 1) : (item.name == '七彩星级') ? _c('div', [_c('van-cell', {
        attrs: {
          "title": "姓名",
          "value": row.name
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "身份证",
          "value": row.num
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "等级",
          "value": row.grade
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "编号",
          "value": row.code
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "日期",
          "value": row.registdate
        }
      })], 1) : (item.name == '执裁经历') ? _c('div', [_c('van-cell', {
        attrs: {
          "title": "姓名",
          "value": row.name
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "身份证",
          "value": row.num
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "赛区",
          "value": row.match_name
        }
      })], 1) : _vm._e()])
    })], 2)
  }), _vm._v(" "), _c('div', _vm._l((_vm.list2), function(row, i) {
    return _c('van-cell-group', {
      key: i
    }, [_c('van-cell', {
      attrs: {
        "title": "姓名",
        "value": row.name
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "身份证",
        "value": row.num
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "等级",
        "value": row.grade
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "编号",
        "value": row.code
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "日期",
        "value": row.registdate
      }
    })], 1)
  }), 1), _vm._v(" "), (_vm.emptyShow) ? _c('div', {}, [_c('van-empty', {
    staticStyle: {
      "margin": "10px auto"
    },
    attrs: {
      "description": "暂无结果"
    }
  })], 1) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50528479","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cha/SearchPerson.vue
// module id = 1447
// module chunks = 0